<template>
	<div class="sampleAssignment">
		<PageHeader @back="goback" :content="'样本回收'" />
		<div class="sampleAssignmentBox">
			<div class="assigningBtn">
				 <el-tooltip class="item" effect="light" content="请选择要回收的样本数据" placement="top">
					<el-button size="medium" type="primary" :disabled="userLaterSampleSelect.length == 0" @click="recycleSample">回收样本</el-button>
				</el-tooltip>
				<el-button size="medium" type="primary" @click="allrecycleSample">回收全部样本</el-button>
			</div>
			<div class="topTableBox">
				<div>
					<el-table class="topLeft" max-height="400" highlight-current-row border :data="userLaterSampleSumDtat" @cell-click="cellClick">
						<el-table-column align="center" fixed label="选择访员">
							<template slot-scope="scope">
								<span :class="userID == scope.row.userId ? 'checkedTrue' : 'checkedFalse'" @click="chooseInterviewer(scope.row)">
									
									<el-radio v-model="userID" :label="scope.row.userId">{{ scope.row.userName }} ( {{ scope.row.count }}个 )</el-radio>
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="topRight">
					<el-table border :data="userLaterSampleDtat" @selection-change="userLaterSampleChange">
						<el-table-column type="selection" width="40" v-if="activeHide"></el-table-column>
						<el-table-column
							v-for="item in columnList"
							:key="item.enfieldName"
							align="center"
							:prop="item.enfieldName"
							:label="item.chfieldName"
							:fixed="item.fixed"
						></el-table-column>

						<el-table-column align="center" fixed="right" label="操作" width="120" v-if="activeHide">
							<template slot-scope="scope">
								<el-link type="primary" :underline="false" @click="viewDetails(scope)">查看样本</el-link>
							</template>
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination
							background
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="pagination.pageNo"
							:page-sizes="[10, 50, 100, 200, 300, 400]"
							:page-size="pagination.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="pagination.total"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<!-- 查看详情 修改样本 -->
		<particulars ref="particulars" :fieldContrast="fieldContrast"></particulars>
	</div>
</template>

<script>
import particulars from './particulars';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		particulars,
		PageHeader
	},
	data() {
		return {
			source: '',
			id: '',
			pagination: {
				pageNo: 1,
				total: 0,
				pageSize: 10
			},
			userLaterSampleSelect: [],
			userLaterSampleSumDtat: [],
			userID: '',
			userLaterSampleDtat: [],

			// 表头
			activeHide: false,
			columnList: [],
			// 查看样本
			fieldContrast: []
		};
	},
	created() {
		this.id = this.$route.query.id;
		this.source = this.$route.query.source;
		this.queryFieldConfig();
		this.queryUserLaterSampleSum(); //查询访员名字以及访员分配样本个数
	},
	methods: {
		cellClick() {
			console.log('e :>> ', e);
			this.userID = e.userId
			this.chooseInterviewer(e)
		},
		// 查看样本/
		viewDetails(scope) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					if (res.code == 0) {
						that.fieldContrast = res.resultBody.questionsFieldMappings;
						that.$refs.particulars.form = JSON.parse(JSON.stringify(scope.row));
						that.$refs.particulars.title = '查看详情';
						that.$refs.particulars.loadData();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 回收全部样本
		allrecycleSample() {
			this.$confirm('将所有样本进行回收操作, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let data = {
						surveyId: this.id,
						userId: this.userID
					};
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.resetUserLaterSample}`,
						method: 'POST',
						data: data,
						cb(res) {
							if (res.code == 0) {
								that.userLaterSampleSumDtat= []
								that.userLaterSampleDtat = []
								that.queryFieldConfig();
								that.queryUserLaterSampleSum(); //查询访员名字以及访员分配样本个数
								that.userID = '';
								that.$message.success(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消操作'
					// });
				});
		},
		// 回收样本
		recycleSample() {
			let data = {
				surveyId: this.id,
				id: this.userLaterSampleSelect.toString()
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.resetLaterSampleByIdList}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						that.userLaterSampleSumDtat= []
						that.userLaterSampleDtat = []
						that.queryFieldConfig();
						that.queryUserLaterSampleSum(); //查询访员名字以及访员分配样本个数
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		queryFieldConfig() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFieldConfig}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询左中右', res);
					if (res.code == 0) {
						if (res.resultBody != '') {
							let leftList = JSON.parse(res.resultBody.leftFieldName);
							let centreList = JSON.parse(res.resultBody.centreFieldName);
							let rigthList = JSON.parse(res.resultBody.rightFieldName);
							leftList.forEach(item => {
								item.fixed = 'left';
							});
							rigthList.forEach(item => {
								item.fixed = 'rigth';
							});
							console.log(leftList, centreList, rigthList);

							let tempAllList = [...leftList, ...centreList, ...rigthList];
							that.activeHide = false;
							tempAllList.forEach((item, index) => {
								if (item.chfieldName == '操作') {
									tempAllList.splice(index, 1);
									that.activeHide = true;
								}
							});
							that.columnList = tempAllList;
						} else {
							that.columnList = [];
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		// 选择访员
		chooseInterviewer(scope) {
			console.log(scope.userId);
			this.userID = scope.userId;
			this.queryUserLaterSample(this.userID);
		},
		queryUserLaterSampleSum() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryUserLaterSampleSum}`,
				method: 'POST',
				data: {
					qid: this.id,
					source: this.source
				},
				cb(res) {
					if (res.code == 0) {
						if (res.resultBody.length > 0) {
							that.userLaterSampleSumDtat = res.resultBody;
							if (that.userLaterSampleSumDtat.length == 0) {
								that.userLaterSampleDtat = [];
								that.pagination.total = 0;
							}
							if (that.userID == '') {
								that.userID = that.userLaterSampleSumDtat[0].userId;
							}
							if (that.userID != '') {
								that.queryUserLaterSample(that.userID); //查询访员的稍后样本
							}
						}
					} else {
						that.userLaterSampleSumDtat = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		userLaterSampleChange(val) {
			let tempUserLaterSample = [];
			val.forEach(item => {
				tempUserLaterSample.push(item.sampleId);
			});
			this.userLaterSampleSelect = tempUserLaterSample;
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val;
			this.pagination.pageNo = 1;
			this.queryUserLaterSample(this.userId);
		},
		handleCurrentChange(val) {
			this.pagination.pageNo = val;
			this.queryUserLaterSample(this.userId);
		},
		queryUserLaterSample(userId) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryUserLaterSample}`,
				method: 'POST',
				data: {
					qid: this.id,
					source: this.source,
					userId: userId,
					currentPage: this.pagination.pageNo,
					pageSize: this.pagination.pageSize
				},
				cb(res) {
					if (res.code == 0) {
						console.log(res);
						that.userLaterSampleDtat = res.resultBody.result;
						that.pagination.total = res.resultBody.totalCount;
					} else {
						that.userLaterSampleDtat = [];
						that.pagination.total = 0;
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style scoped lang="scss">
.sampleAssignment {
	margin: 0px;
	padding: 0px;
	width: 100%;
	height: 100%;
	.details_header {
		// max-width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #0080ff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			// color: #333333;
			color: #fff;
			font-size: 16px;
			padding: 0px 30px;
		}
		margin-bottom: 20px;
		cursor: pointer;
	}
	.sampleAssignmentBox {
		width: 100%;
		.topTableBox {
			padding: 20px;
			display: flex;
			justify-content: space-between;
			.el-table {
				flex: none;
			}
			.topLeft {
				width: 200px;
				margin-right: 20px;
				.checkedTrue {
					cursor: pointer;
					color: #0080ff;
				}
				.checkedFalse {
					cursor: pointer;
				}
			}
			.topRight {
				width: calc(100% - 250px);
				flex: 1;
				.block {
					text-align: right;
					margin-top: 20px;
				}
			}
		}
	}
}

.assigningBtn {
	padding: 0 20px;
	text-align: right;
}
</style>
